module.exports = __webpack_public_path__ + "img/conclusionimg.a001fc82.svg";